import ENV from '@/config'
import init from './modal'
import leavingSiteModal from './leavingSiteModal'

if ( ENV.leavingSiteModal.enabled ) leavingSiteModal()
init()
